import React from "react";
import { ReactComponent as LightingIcon } from "../SVGcomponents/lighting.svg";
import { ReactComponent as RightArrow } from "../SVGcomponents/rightIcon.svg";
import { ReactComponent as FAQItem } from "../SVGcomponents/FAQ.svg";
import MenuItem from "../MenuItem";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";

type Props = {
  open: boolean;
  hideVersion?: boolean;
  asAdditionalComponent?: boolean;
  customStyles?: {
    fontSize?: string;
    linkColor?: string;
    separatorColor?: string;
    fontWeight?: string;
    textDecoration?: string;
    marginTop?: string;
    marginBottom?: string;
    padding?: string;
    containerClassName?: string;
    linkClassName?: string;
    separatorClassName?: string;
    alignItems?: string;
  };
};

export const AdvancedMode = ({
  open,
  hideVersion = false,
  asAdditionalComponent = false,
  customStyles,
}: Props) => {
  const location = useLocation();

  return (
    <div
      className={`${styles["advance"]} ${asAdditionalComponent ? styles.asAdditionalComponent : ""}`}
    >
      <div className={`${styles["help-item"]} ${open && styles["collapsed"]}`}>
        {/*<MenuItem*/}
        {/*  MenuItemLogoSVG={FAQItem}*/}
        {/*  svgStyles={{*/}
        {/*    width: "40px",*/}
        {/*    height: "40px",*/}
        {/*    background: "var(--color-filter-modal-item-border, #F2F4FC)",*/}
        {/*    borderRadius: "14px",*/}
        {/*    textAlign: "center",*/}
        {/*  }}*/}
        {/*  text={!open ? "Help" : " "}*/}
        {/*  isActive={getCurrentlyActiveLink("/FAQ")}*/}
        {/*  link={"FAQ"}*/}
        {/*/>*/}
      </div>
    </div>
  );
};
